var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('invitationform.title')))]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.$t('invitationform.text')))]),_vm._v(" "),_c('text-input',{attrs:{"config":{
        type: 'email',
        required: true,
        label: _vm.$t('invitationform.labels.email'),
        errors: (_vm.error.email || []).map(function (e) { return function () { return e; }; })
      }},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('text-input',{attrs:{"config":{
        type: 'password',
        label: _vm.$t('invitationform.labels.password'),
        hint: _vm.$t('invitationform.hints.password'),
        persistentHint: true,
        errors: (_vm.error.password || []).map(function (e) { return function () { return e; }; })
      }},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{attrs:{"type":"submit","primary":"","light":"","ripple":"","loading":_vm.loading}},[_vm._v("\n        "+_vm._s(_vm.$t('invitationform.submit'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af225384","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvitationForm.vue
// module id = null
// module chunks = 